
import Layout from '@/layout/TheLayout.vue'
import { EXTRANET_GROUPS, SUPPLIER_GROUPS_LOW_TIER, JR_ACO_GROUP, SR_ACO_GROUP } from './utils'

export default [
  {
    path: '/',
    name: 'businessUnits',
    component: Layout,
    meta: {
      excludeGroup: [...EXTRANET_GROUPS, ...SUPPLIER_GROUPS_LOW_TIER, 'DesProveedores', JR_ACO_GROUP, SR_ACO_GROUP]
    },
    children: [
      {
        path: '/unidades_de_negocio',
        name: 'Business Units',
        component: () => import('@/pages/catalogs/businessUnits/index.vue'),
        meta: {
          title: 'Unidades de negocio',
          showInSidebar: true,
          icon: 'mdi-briefcase',
          ifCan: {
            view: 'zones/businessunits'
          }

        }
      }
    ]
  }
]
